<template>
    <Head title="Update Question" />
    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-xl leading-tight">
                Update Question - {{ question.title }}
            </h2>
        </template>

        <BreadCrumbs :items="navItems"></BreadCrumbs>

        <div class="w-full my-6 rounded py-12 shadow-lg">
            <div class="px-6 pt-4 pb-2">
                <form enctype="multipart/form-data" @submit.prevent="submit" class="w-full">
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Title</admin-app-label>
                            <input-basic
                                placeholder="Title"
                                v-model="form.title"
                                :error="errors['title']"
                            />
                            <input-error v-if="errors['title']">
                                {{ errors.title }}
                            </input-error>
                        </div>
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Question</admin-app-label>
                            <input-basic
                                placeholder="Question"
                                v-model="form.question"
                                :error="errors['question']"
                            />
                            <input-error v-if="errors['question']">
                                {{ errors.question }}
                            </input-error>
                        </div>
                    </div>
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Product Type</admin-app-label>
                            <input-select
                                placeholder="Product Type"
                                labelKey="Product Type"
                                label="label"
                                :options="productTypes"
                                :error="errors['product_type']"
                                :reduce="(productTypes) => productTypes.id"
                                v-model="form.product_type"
                            ></input-select>
                            <input-error v-if="errors['product_type']">
                                {{ errors.product_type }}
                            </input-error>
                        </div>
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Question Type</admin-app-label>
                            <input-select
                                placeholder="Question Type"
                                labelKey="Question Type"
                                label="label"
                                :options="questionTypes"
                                :error="errors['type']"
                                :reduce="(questionTypes) => questionTypes.id"
                                v-model="form.type"
                            ></input-select>
                            <input-error v-if="errors['type']">
                                {{ errors.type }}
                            </input-error>
                        </div>
                    </div>

                    <div class="flex items-center">
                        <input-checkbox class="mr-1" v-model="form.required">
                            Required
                        </input-checkbox>
                    </div>

                    <app-button type="submit" class="mt-8">Update</app-button>
                </form>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>
<script>
import InputBasic from "@/Components/Admin/Forms/Inputs/InputBasic";
import InputError from "@/Components/Forms/Inputs/InputError";
import AdminAppLabel from "@/Components/Admin/Forms/AdminAppLabel";
import { Head, useForm } from '@inertiajs/inertia-vue3';
import BreezeAuthenticatedLayout from '@/Layouts/Admin/Authenticated.vue'
import InputSelect from "@/Components/Admin/Forms/Inputs/InputSelect";
import AppButton from "@/Components/AppButton";
import BreadCrumbs from "@/Components/Admin/BreadCrumbs";
import InputCheckbox from "@/Components/Forms/Inputs/InputCheckbox";
export default
{
    components:
        {
            InputCheckbox,
            BreadCrumbs,
            AppButton,
            InputSelect,
            InputError,
            InputBasic,
            AdminAppLabel,
            Head,
            BreezeAuthenticatedLayout,
        },
    props: {
        errors: Object,
        question: Object,
    },
    data() {
        return {
            navItems: [
                { title: 'Questions', path: '/admin/questions' },
            ],
            productTypes: [
                { label: 'Fitter', id: 'fitter' },
                { label: 'Tyre', id: 'tyre' },
                { label: 'Website', id: 'website' },
                { label: 'Product', id: 'product' }
            ],
            questionTypes: [
                { label: 'Rating', id: 'rating' },
                { label: 'Yes / No', id: 'yesno' },
                { label: 'Answer', id: 'answer' }
            ],
        }
    },
    mounted() {
        var valueToPush = { };
        valueToPush.title = '#'+ this.question.id;
        valueToPush.path = "/admin/questions/"+this.question.id+"/edit";

        this.navItems.push(valueToPush);
    },
    setup(props) {
        const form = useForm(
            {
                title: props.question.title,
                question: props.question.question,
                product_type: props.question.product_type,
                type: props.question.type,
                required: props.question.required
            }
        );

        return { form };
    },
    methods: {
        submit() {
            this.form.put(this.route("admin.questions.update", this.question.id));
        }
    }
}
</script>
